"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _UnreachableCaseError = require("@oberoninternal/travelbase-ds/entities/UnreachableCaseError");
var _createBorderCss = _interopRequireDefault(require("@oberoninternal/travelbase-ds/utils/createBorderCss"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
const _excluded = ["step", "variant", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const WizardStep = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
      step,
      variant,
      children
    } = props,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  return __jsx(Container, (0, _extends2.default)({
    variant: variant
  }, rest, {
    ref: ref
  }), __jsx(Circle, null, step), __jsx(StyledBody, null, children));
});
var _default = exports.default = WizardStep;
const StyledBody = (0, _styledComponents.default)(_Body.default).attrs({
  variant: 'tiny'
}).withConfig({
  displayName: "WizardStep__StyledBody",
  componentId: "sc-1o9i7hw-0"
})(["color:", ";"], ({
  theme
}) => theme.colors.neutral['50']);
const Circle = _styledComponents.default.div.withConfig({
  displayName: "WizardStep__Circle",
  componentId: "sc-1o9i7hw-1"
})(["", " display:flex;align-items:center;justify-content:center;background:", ";--border-color:", ";font-weight:600;color:", ";border-radius:50%;width:calc(var(--circle-dimension) * 1px);height:calc(var(--circle-dimension) * 1px);flex-shrink:0;z-index:1;"], (0, _createBorderCss.default)('2px'), ({
  theme
}) => theme.colors.secondary['30'], ({
  theme
}) => theme.colors.secondary['30'], ({
  theme
}) => theme.colors.neutral['0']);
const todoCss = (0, _styledComponents.css)(["", "{background:", ";color:", ";--border-color:", ";}"], Circle, ({
  theme
}) => theme.colors.neutral['0'], ({
  theme
}) => theme.colors.neutral['50'], ({
  theme
}) => theme.colors.neutral['20']);
const activeCss = (0, _styledComponents.css)(["", "{color:", ";}"], StyledBody, ({
  theme
}) => theme.colors.neutral['100']);
const doneCss = (0, _styledComponents.css)([""]);
const disabledCss = (0, _styledComponents.css)(["&&{", "{background:", ";--border-color:", ";color:", ";}::after{background:", ";}}"], Circle, ({
  theme
}) => theme.colors.neutral['20'], ({
  theme
}) => theme.colors.neutral['20'], ({
  theme
}) => theme.colors.neutral['50'], ({
  theme
}) => theme.colors.neutral['20']);
const getCss = variant => {
  switch (variant) {
    case 'todo':
      return todoCss;
    case 'active':
      return activeCss;
    case 'done':
      return doneCss;
    case 'disabled':
      return disabledCss;
    default:
      throw new _UnreachableCaseError.UnreachableCaseError(variant);
  }
};
const Container = _styledComponents.default.div.withConfig({
  displayName: "WizardStep__Container",
  componentId: "sc-1o9i7hw-2"
})(["width:100%;position:relative;display:flex;align-items:center;cursor:pointer;@media screen and (max-width:", "px){flex-direction:column;--circle-dimension:24;:not(:first-of-type)::after{content:'';width:100%;right:50%;height:2px;top:calc(var(--circle-dimension) / 2 * 1px - 1px);position:absolute;background:", ";}> * + *{margin-top:", ";}}@media screen and (min-width:", "){flex-direction:row;--circle-dimension:32;> * + *{margin-left:", ";}}", ";"], ({
  theme
}) => theme.mediaQueriesValues.s - 1, ({
  theme,
  valid
}) => valid ? theme.colors.secondary['30'] : theme.colors.neutral['20'], ({
  theme
}) => theme.spacing['30_Small'], ({
  theme
}) => theme.mediaQueries.s, ({
  theme
}) => theme.spacing['30_Small'], ({
  variant = 'todo'
}) => getCss(variant));